import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=ca038036"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca038036')) {
      api.createRecord('ca038036', component.options)
    } else {
      api.reload('ca038036', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=ca038036", function () {
      api.rerender('ca038036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/Register.vue"
export default component.exports